import Chip from '@material-ui/core/Chip';
import { green, red } from '@material-ui/core/colors';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import classNames from 'classnames';
import moment from 'moment';
import React from 'react';
import Gravatar from '../../../common/Gravatar';
import TimestampTooltip from '../../../common/TimestampTooltip';

const useStyles = makeStyles(() =>
    createStyles({
        root: {
            alignItems: 'center'
        },
        timelineAvatar: {
            marginTop: 0
        },
        rejectedChip: {
            color: red[500],
            margin: '0 8px'
        },
        approvedChip: {
            color: green[500],
            margin: '0 8px'
        },
        timestamp: {
            marginLeft: 8
        },
        actionsPopoverText: {
            cursor: 'pointer'
        }
    })
);

interface Props {
    event: any;
    className?: string;
    onOpenPopover: (target: HTMLElement, event: any) => void;
    onClosePopover: () => void;
}

function ApprovalTimelineEvent(props: Props) {
    const classes = useStyles({});
    const { event, className } = props;

    function onOpenPopover(e: React.MouseEvent<HTMLElement, MouseEvent>) {
        props.onOpenPopover(e.currentTarget, event);
    }

    return (
        <ListItem key={event.id} alignItems="flex-start" className={classNames(classes.root, className)}>
            <ListItemAvatar className={classes.timelineAvatar}>
                <Gravatar email={event.email} />
            </ListItemAvatar>
            <ListItemText
                primary={
                    <React.Fragment>
                        {event.user}
                        <Chip
                            className={event.approved ? classes.approvedChip : classes.rejectedChip}
                            size="small"
                            variant="outlined"
                            label={event.approved ? 'approved' : 'rejected'}
                        />
                        <span className={classes.actionsPopoverText} onMouseEnter={onOpenPopover} onMouseLeave={props.onClosePopover}>
                            {event.actions.length} action{event.actions.length !== 1 ? 's' : ''}
                        </span>
                        <TimestampTooltip timestamp={event.timestamp}>
                            <Typography
                                className={classes.timestamp}
                                component="span"
                                display="inline"
                                color="textSecondary"
                            >
                                - {moment(event.timestamp).fromNow()}
                            </Typography>
                        </TimestampTooltip>
                    </React.Fragment>
                }
            />
        </ListItem>
    );
};

export default ApprovalTimelineEvent;
